<!-- Toast Messages -->
<p-toast
  data-testid="synchronization-view-toast"
  position="top-right"
  [baseZIndex]="9999"
  [autoZIndex]="true"
  [showTransformOptions]="'translateX(100%)'"
  [hideTransformOptions]="'translateX(100%)'"
  [showTransitionOptions]="'0.3s ease-in'"
  [hideTransitionOptions]="'0.3s ease-out'"
  [preventDuplicates]="false"
></p-toast>

@if (loading()) {
<div class="flex items-center justify-center py-12">
  <div
    data-testid="synchronization-view-loading"
    class="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"
  ></div>
</div>
} @else {
<!-- Form Section (View Mode) -->
<app-synchronization-form
  data-testid="synchronization-view-form-wrapper"
  [config]="config"
  [editMode]="false"
  [viewMode]="true"
  [initialData]="synchronizationData()"
  [height]="height"
></app-synchronization-form>

<!-- Product Details Table Section -->
<div class="px-6">
  <div class="p-2">
    <h2 class="text-xl font-semibold text-gray-900">
      {{ 'synchronization.form.sections.product_details' | translate }}
    </h2>
    <div class="p-2">
      <app-data-table
        data-testid="synchronization-view-product-details-table"
        [dataSource]="synchronizationData()?.adjustDetailsReqDTOList || []"
        [columns]="viewTableColumns"
        [rows]="20"
        [first]="0"
        [totalRecords]="(synchronizationData()?.adjustDetailsReqDTOList || []).length"
        [loading]="false"
        scrollHeight="400px"
      >
        <!-- Custom Adjustment Type Template -->
        <ng-template #customTemplate let-value>
          <span 
            [class]="getAdjustmentTypeClass(value)"
            class="px-2 py-1 rounded-full flex justify-center items-center text-xs font-medium"
          >
            {{ getAdjustmentTypeText(value) }}
          </span>
        </ng-template>
      </app-data-table>
    </div>
  </div>
</div>
}
